import {
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@ais-ui/ui-core';
import React, { useState } from 'react';
import { PiDiamond } from 'react-icons/pi';
import { useLocalization } from '@ais-ui/locale-management';
import { GhVirtualAton } from '../../assets/icons/GhVirtualAton';
import { useAtonContext } from './AtonContext';

interface AtonButtonProps {
  id: string;
  Icon: React.ElementType;
  onClick: () => void;
  text: string;
}

const AtonButton = ({ id, Icon, onClick, text }: AtonButtonProps) => {
  return (
    <Button
      id={id}
      variant="ghost"
      onClick={onClick}
      className="flex gap-x-2 col-span-2 justify-start"
    >
      <Icon className="size-4"></Icon>
      {text}
    </Button>
  );
};

interface AtonActionsMenuProps {
  buttonText: string;
  className?: string;
}

export const AtonActionsMenu = ({
  buttonText,
  className,
}: AtonActionsMenuProps) => {
  const { messages } = useLocalization();
  const [isOpen, setIsOpen] = useState(false);
  const { physicalForm, setShowDialog, setAtonType, setMutateType, setAton } =
    useAtonContext();

  const onStartCreate = (newAtonType: string) => {
    setAton(null);
    physicalForm.reset({
      name: '',
      description: '',
      warningTimeout: '00:07:00',
      failureTimeout: '00:13:00',
      alarms: [],
      selectedGroups: [],
    });
    setAtonType(newAtonType);
    setMutateType('create');
    setShowDialog(true);
  };

  return (
    <div className="flex w-full justify-end">
      <Popover open={isOpen} onOpenChange={setIsOpen}>
        <PopoverTrigger asChild>
          <Button id="create-aton-button" className={className}>
            {buttonText}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-fit" side="left" align="end">
          <div className="grid gap-4">
            <div className="space-y-2">
              <h4 className="font-medium leading-none">
                {messages.atonActionsMenuTitle}
              </h4>
              <p className="text-sm text-muted-foreground">
                {messages.atonActionsMenuSubtitle}
              </p>
            </div>
            <div className="grid gap-2"></div>
          </div>
          <div className="grid grid-cols-4">
            <AtonButton
              id="create-physical-aton-button"
              onClick={() => {
                onStartCreate('physical');
              }}
              Icon={PiDiamond}
              text={messages.atonActionsMenuPhysicalAtonText}
            ></AtonButton>
            <AtonButton
              id="create-virtual-aton-button"
              onClick={() => {
                onStartCreate('virtual');
              }}
              Icon={GhVirtualAton}
              text={messages.atonActionsMenuVirtualAtonText}
            ></AtonButton>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};
